import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/shared";
import { IMAGES } from "@/lib/site";

const FEATURES = [
  "Relatórios técnicos", "Fotografias", "Inspeções", "Histórico do condomínio",
  "Patologias", "Plano de ação", "Orçamentos", "Obras", "Documentos",
  "Agenda de visitas", "Indicadores técnicos",
];

export default function RealizaTech() {
  return (
    <section className="relative overflow-hidden py-28 lg:py-36">
      <div className="absolute inset-0">
        <img src={IMAGES.techBg} alt="" aria-hidden="true" className="h-full w-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-navy-950/90" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-transparent to-navy-950" />
      </div>
      <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
        <Reveal>
          <span className="inline-block rounded-full border border-gold/40 bg-navy-950/70 px-5 py-1.5 font-mono text-[10px] uppercase tracking-[0.3em] text-gold backdrop-blur">
            Em breve — Portal do Síndico
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-7 font-display text-5xl font-extrabold uppercase tracking-wide sm:text-6xl lg:text-7xl">
            <span className="text-gold-grad">Realiza Tech</span>
          </h2>
          <p className="mt-2 font-mono text-xs uppercase tracking-[0.3em] text-slate-400">
            Gestão Técnica Condominial
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mx-auto mt-7 max-w-2xl leading-relaxed text-slate-400">
            O portal exclusivo dos clientes Realiza: acompanhe vistorias, laudos fotográficos,
            obras e cronogramas em tempo real — todo o histórico técnico do seu condomínio na
            palma da sua mão.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <div className="mx-auto mt-10 flex max-w-2xl flex-wrap justify-center gap-2.5">
            {FEATURES.map((f) => (
              <span key={f} className="rounded-full border border-white/12 bg-white/[0.04] px-4 py-2 text-xs text-slate-300 backdrop-blur transition-colors duration-300 hover:border-gold/40 hover:text-gold">
                {f}
              </span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.34}>
          <a
            href="https://wa.me/5551981779245?text=Ol%C3%A1!%20Quero%20saber%20mais%20sobre%20o%20REALIZA%20TECH%2C%20o%20portal%20do%20s%C3%ADndico."
            target="_blank"
            rel="noopener noreferrer"
            data-testid="realiza-tech-cta"
            className="mt-11 inline-flex items-center gap-2 rounded-full border border-gold/50 px-8 py-4 font-display text-sm font-bold tracking-[0.14em] text-gold transition-all duration-300 hover:bg-gold hover:text-navy-950"
          >
            QUERO ACESSO QUANDO LANÇAR <ArrowUpRight className="h-4 w-4" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
